import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-backend-service-unavailable',
    templateUrl: './dialog-backend-service-unavailable.component.html',
    styleUrls: ['./dialog-backend-service-unavailable.component.css'],
    standalone: false
})
export class DialogBackendServiceUnavailableComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DialogBackendServiceUnavailableComponent>
    ) { }

    ngOnInit(): void { }
}
